<template>
  <div class="fx-1 fx-col calendar">
    <c-nav></c-nav>
    <!-- calender head -->
    <div :class="['header', isNavShow ? 'nav-show' : '']">
      <div class="iphonexTop">
      </div>
      <div class="fx-row">
        <div class="fx-1" v-for="(week, index) of weeks" :key="index">{{week}}</div>
      </div>
    </div>
    <!-- calender body -->
    <div class="body fx-1">
      <div v-for="(m, index) of calendar" :key="index">
        <!-- month -->
        <div class="month">{{m.month}}</div>
        <!-- days -->
        <div class="days">
          <div class="fx-row" v-for="(days, index) of m.week" :key="index">
            <div class="fx-1 cell" v-for="(day, index) of days" :key="index">
              <template v-if="day">
                <div :class="cellStyle(day)" @click="selectDate(day)">
                  <div>{{day.day}}</div>
                  <label class="top green" v-if="day.status == 'today'">今天</label>
                  <label class="top red" v-else-if="day.worktime == '1'">班</label>
                  <label class="top green" v-else-if="day.worktime == '2'">休</label>
                  <label class="bottom gray" v-if="day.status != 'grab' && day.desc">{{day.desc}}</label>
                  <label class="bottom orange" v-if="day.status == 'grab'">约抢</label>
                </div>
              </template>
              <!-- 空占位 -->
              <template v-else>
                <div></div>
              </template>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="showLoading">
      <uiLoading :show="showLoading" type="dot"></uiLoading>
    </div>
  </div>

</template>

<script>
import calendar from "./calendar";
import uiLoading from "@/ui/base/components/loading.vue"; // 单独调用loading组件
import chunk from "../../utils/common/chunk.js";
import _ from "../../utils/datetime.js";

//日历显示多少个月
// const SHOW_MONTHS_COUNT = 6;
const SHOW_MONTHS_COUNT = 12;
//月数字转中文
const MONTHS = {
  "1": "一",
  "2": "二",
  "3": "三",
  "4": "四",
  "5": "五",
  "6": "六",
  "7": "七",
  "8": "八",
  "9": "九",
  "10": "十",
  "11": "十一",
  "12": "十二"
};
//周
const WEEKS = ["日", "一", "二", "三", "四", "五", "六"];
//日历有效期
let ActiveDays = {
  activePastDays: false, //今天之前是否可选
  futureTimeCanSelect: true, //今天以后是否可选
  presellDay: 30, //购票有效期
  appointGrabDay: 7 //抢票有效期
};
//当前日期(北京时间)
let current = null;

import API from "../../api";

export default {
  name: "calendar",
  // props: ["defaultDate"],
  components: {
    uiLoading
  },
  data() {
    return {
      weeks: WEEKS,
      calendar: false,
      select: false,
      isNavShow: this.$nav && this.$nav.show,
      departDate: _.format("%Y-%m-%d", new Date()),
      onSelect: null,
      showLoading: true
    };
  },
  methods: {
    setPageColor( color ) {
      document.body.style.backgroundColor = color;
    },

    initCalendar() {
      current = _.getBeijingDate();
      this.select = checkSelected(this.departDate);
      this.calendar = getCalendar();
      this.showLoading = false // 关闭loading
    },
    cellStyle(day) {
      let result = [day.status];

      if (day.date == this.select) {
        result.push("select");
      }

      return result;
    },
    selectDate(day) {
      //日期可选
      // if (day && day.status != "invalid" && day.date) {
      if ( day && day.date ){
        // this.$emit("calendarSelected", day.date);
        if (this.onSelect && typeof this.onSelect === "function") {
          this.onSelect(day.date);
        }
        this.$router.back();
      }
    }
  },
  created() {
    let { departDate, onSelect } = this.$route.params;
    this.onSelect = onSelect ? onSelect : null;
    if (departDate) this.departDate = departDate;

    API.calendar["331546"]()
      .catch(() => {
        return;
      })
      .then(res => {
        if (res && res.appointGrabDay && res.presellDay) {
          ActiveDays.presellDay = res.presellDay;
          ActiveDays.appointGrabDay = res.appointGrabDay;
        }
        setTimeout(() => {
          this.initCalendar();
        }, 400);
      });
  },

  mounted() {
    this.setPageColor( '#ffffff' );
  }
};

function checkSelected(selected) {
  let result = "";

  if (selected && diffDay(current, selected) >= 0) {
    result = selected;
  } else {
    result = "";
  }

  return result;
}

//初始化日历控件
function getCalendar() {
  // 肺炎日历
  const virus = true;

  //获取当前年
  let startYear = current.getFullYear();
  //获取当前月
  let startMonth = current.getMonth() + 1;
  //要显示的年和月列表
  let yearAndMonthList = [];
  let endMonth,
    calendarList = [];

  // 展示上个月

  if ( virus ) {
    startMonth = 12;
    startYear--;
  }

  //计算应该取跨度为半年的所有月份
  for (let i = 0; i <= SHOW_MONTHS_COUNT; i++) {
    endMonth = startMonth + i;

    //月份未垮年
    if (endMonth <= 12) {
      yearAndMonthList.push([startYear, endMonth]);
    } else {
      let nextYear = startYear + 1;
      yearAndMonthList.push([nextYear, endMonth - 12]);
    }
  }

  //依据年/月获取每月日期数据
  calendarList = yearAndMonthList.map(getDateByYearAndMonth);
  //依据周补差日期数据
  calendarList = calendarList.map(groupDateByWeek);

  return calendarList;
}

//获取指定年，月的日期信息
function getDateByYearAndMonth([year, month]) {
  let date = calendar.calendar(year, month);
  let days = {
    year,
    month,
    firstDay: date.firstDay,
    days: date.monthData.map(day => {
      return setDay(year, month, day);
    })
  };

  return days;
}

function groupDateByWeek(item) {
  return {
    month: formatMonth(item),
    week: setDaysByWeek(item)
  };
}

//返回用于显示的月份信息
function formatMonth({ year, month }) {
  let result = `${MONTHS[month]}月`;

  //日历第一个月要显示年份
  if (current.getMonth() == month - 1 || month == "1") {
    result = `${year}年${result}`;
  }

  return result;
}

//根据周将days分组补齐
function setDaysByWeek({ days, firstDay }) {
  //日历firstDay:0（周日），1（周一），2（周二），3（周三），4（周四），5（周五），6（周六）
  //头补齐
  let starts = new Array(firstDay);
  days = starts.concat(days);

  //尾补齐
  let lastDay = 7 - (days.length % 7);
  let ends = new Array(lastDay);
  days = days.concat(ends);

  //以一周7天分组
  days = chunk(days, 7);

  return days;
}

//为日期设置状态（是否可选，是否今天，是否可抢票...）
function setDay(year, month, day) {
  let status = "invalid";
  let date = [year, month, day.day].join("/");
  let diff = diffDay(current, date);

  //过去
  if (diff < 0) {
    if (ActiveDays.activePastDays && ActiveDays.activePastDays <= diff) {
      status = "active";
    }
  } else if (diff == 0) {
    //今天
    status = "today";
  } else if (diff > 0 && diff < ActiveDays.presellDay) {
    //可选
    status = "active";
  } else if (
    diff >= ActiveDays.presellDay &&
    diff < Number(ActiveDays.presellDay) + Number(ActiveDays.appointGrabDay)
  ) {
    //可约抢
    status = "grab";
  } else if (ActiveDays.futureTimeCanSelect) {
    //未来
    status = "notyet";
  }

  return {
    //日期格式化为'2018-01-01'形式
    date: formatDate(year, month, day.day),
    worktime: day.worktime,
    day: day.day,
    desc: getDayDesc(day),
    status
  };
}

//格式化日期
function formatDate(year, month, day) {
  return [
    year,
    month < 10 ? "0" + month.toString() : month,
    day < 10 ? "0" + day.toString() : day
  ].join("-");
}

//获取日描述信息
function getDayDesc(day) {
  //需要解析的日期描述字段优先级
  let priority = ["solarFestival", "lunarFestival", "term", "lunarDayName"];
  let result = "";
  let len = priority.length;

  for (let i = 0; i < len; i++) {
    let key = priority[i];
    if (day[key]) {
      result = day[key];
      break;
    }
  }
  return result;
}

function ensureDate(input, beijingtime) {
  const SUPPORTED_DATE_LEN = {
    3: "Year:Month:Day",
    5: "Year:Month:Day Hour:Minutes",
    6: "Year:Month:Day Hour:Minutes:Seconds"
  };
  let date = null;

  if (typeof input == "number") {
    if (beijingtime) {
      //设置成北京时间
      date = _.getBeijingDate(input);
    } else {
      date = new Date();
      date.setTime(input);
    }
  } else if (typeof input == "string") {
    let parts = input.split(/[- :\/]/);
    if (parts.length in SUPPORTED_DATE_LEN) {
      date = new Date(
        parts[0],
        parts[1] - 1,
        parts[2],
        parts[3] || "",
        parts[4] || "",
        parts[5] || ""
      );
    }
  } else if (input instanceof Date) {
    date = input;
  }

  return date;
}

function diffDay(left, right) {
  const ONE_DAY = 24 * 3600 * 1000;
  let leftDate = ensureDate(left),
    rightDate = ensureDate(right);

  return Math.ceil((rightDate - leftDate) / ONE_DAY);
}
</script>

<style lang="scss" scoped>
@import "@/scss/_vars.scss";

$c1: #333333;
$c2: #f1f1f1;
$c3: #000000;
$c4: #4889db;
$c5: #999999;
$c6: #6ebf04;
$c7: #ffffff;
$c8: red;
$c9: #cccccc;
$c10: #ffaf2b;

$rem10: 10 * $px;
$rem12: 12 * $px;
$rem13: 13 * $px;
$rem19: 19 * $px;

@mixin b-b() {
  border-bottom: 1px solid $c2;
}

@mixin p-l-r-20() {
  padding: 0 20 * $px;
}

.calendar {
  font-size: $rem13;
  padding-top: 40 * $px;
  position: fixed;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;

  .header {
    width: 100%;
    height: 40 * $px;
    line-height: 40 * $px;
    text-align: center;
    position: absolute;
    top: 0;
    left: 0;
    color: $c1;
    font-size: $rem13;

    @include b-b;

    &.nav-show {
      top: 40 * $px;
    }
  }

  .body {
    overflow: auto;
    -webkit-overflow-scrolling: touch;

    .month {
      height: 48 * $px;
      line-height: 48 * $px;
      font-size: $rem19;
      color: $c3;

      @include p-l-r-20;
    }

    .days {
      text-align: center;

      .cell {
        color: $c4;
        position: relative;

        > div {
          width: 80%;
          margin: 0 auto;

          > div {
            height: 52 * $px;
            line-height: 52 * $px;
          }

          label {
            width: 100%;
            font-size: $rem10;
            -webkit-transform-origin-x: 0.1;
            -webkit-transform: scale(0.8);
            position: absolute;
            left: 0;
          }

          .top {
            top: 4 * $px;
          }

          .bottom {
            bottom: 4 * $px;
          }

          .red {
            color: $c8;
          }

          .green {
            color: $c6;
          }

          .gray {
            color: $c5;
          }

          &.select {
            > div {
              background-color: $c4;
              border-radius: 3 * $px;
            }

            div,
            label {
              color: $c7 !important;
            }
          }

          &.invalid {
            /* color: $c5; */

            color: #333333;

            div {
              /* color: $c9; */
              color : #333333;
            }
          }

          &.grab {
            color: $c10;

            div {
              color: $c3;
            }
          }

          &.notyet {
            div {
              color: $c3;
            }
          }
        }
      }
    }
  }

  .body::-webkit-scrollbar {
    display: none;
  }
}

.iphonexTop {
  width  : 100%;
  height : 0;
  height : constant( safe-area-inset-top );
  height : env( safe-area-inset-top );
}
</style>



// WEBPACK FOOTER //
// src/pages/calendar/index.vue